import { TagTypes } from "../../../Api/Types/tagTypes";
import { Discount } from "../Types/discountTypes";
import { discountsApi } from "./discountsApi";

export const extendedDiscountApi = discountsApi.injectEndpoints({
	endpoints: (builder) => ({
		getDiscountWithBookingIds: builder.query<Discount, number>({
			query: (id) => `discounts/${id}/bookings/`,
			providesTags: (result, error, id) => [{ type: TagTypes.Discount, id }],
		}),
		assignBookingIdsToDiscount: builder.mutation<
			Discount,
			{ discountId: number; bookingIds: number[] }
		>({
			query: ({ discountId, bookingIds }) => ({
				url: `discounts/${discountId}/assign-bookings/`,
				method: "PUT",
				body: bookingIds,
			}),
			invalidatesTags: (result, error, { discountId }) => [
				{ type: TagTypes.Discount, id: discountId },
			],
		}),
	}),
	overrideExisting: false,
});
export const {
	useGetDiscountWithBookingIdsQuery,
	useAssignBookingIdsToDiscountMutation,
} = extendedDiscountApi;
